import { ReactElement } from "react";
import ButtonGroup from "./ButtonGroup";
import { Text } from "@twilio-paste/core/text";
import { Box } from "@twilio-paste/core/box";
import { ProductSupportIcon } from "@twilio-paste/icons/esm/ProductSupportIcon";
import { Button } from "@twilio-paste/core/button";
import {
  ButtonGroupBlock,
  LoginCTABlock,
  trackingDetails,
} from "@twiliointernal/org/twilio/e2-commons/shared/definitions";
import { useWiseOwlContext } from "../../../hooks";
import { constants } from "../definitions";

interface LoginCTABlockRendererProps {
  block: ButtonGroupBlock | LoginCTABlock;
}

const LoginCTARenderer = ({
  block,
}: LoginCTABlockRendererProps): ReactElement => {
  const {
    chatId,
    handlers: { handleRedirectAction, handleTrackEvent },
  } = useWiseOwlContext();

  const handleButtonTrackingEvent = (): void => {
    if (handleTrackEvent) {
      handleTrackEvent(
        trackingDetails.wiseOwlButtonActionClicked(
          constants.SUBMIT_TICKET_TEXT
        ),
        {}
      );
    }
  };

  const handleTicketSubmit = () => {
    handleButtonTrackingEvent();
    if (handleRedirectAction) {
      const submitPath = `${constants.SUBMIT_TICKET_PATH}${
        chatId ? `?chatId=${chatId}` : ""
      }`;
      !!handleRedirectAction && handleRedirectAction(submitPath);
    }
  };

  return (
    <>
      <ButtonGroup block={block as ButtonGroupBlock} />
      <Box
        marginTop="space50"
        border="initial"
        borderStyle={"solid"}
        borderColor={"colorBorderDecorative10Weaker"}
        padding="space40"
        borderRadius="borderRadius20"
        display={"flex"}
        flexDirection={"row"}
      >
        <Box marginRight="space40">
          <ProductSupportIcon decorative={true} title="Can't login?" />
        </Box>
        <Text as="div" marginRight="space20">
          Can't login?
        </Text>
        <Box as="div">
          <Button onClick={handleTicketSubmit} variant="link">
            {constants.SUBMIT_TICKET_TEXT}
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default LoginCTARenderer;
